export default __webpack_public_path__ + "static/media/mauern-1.77f86b63.jpeg";